const trimControlValue = (trim: string[], value: string): string => {
  let result = value;

  if (trim.includes('left')) {
    result = result.trimStart();
  }

  if (trim.includes('right')) {
    result = result.trimEnd();
  }

  return result;
};

export default trimControlValue;
